"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var svgDrawer_1 = require("./svgDrawer");
var ArcSVGDrawer = /** @class */ (function (_super) {
    tslib_1.__extends(ArcSVGDrawer, _super);
    function ArcSVGDrawer() {
        return _super.call(this, "path", "arc fill") || this;
    }
    ArcSVGDrawer.prototype._applyDefaultAttributes = function (selection) {
        selection.style("stroke", "none");
    };
    return ArcSVGDrawer;
}(svgDrawer_1.SVGDrawer));
exports.ArcSVGDrawer = ArcSVGDrawer;



//////////////////
// WEBPACK FOOTER
// ./src/drawers/arcDrawer.ts
// module id = 47
// module chunks = 0